
// // index announcement bar
new Splide(".announcement-splide", {
  type: "loop",
  perPage: 4,
  arrows: false,
  pagination: false,
  focus: "center",
  gap: "1em"
}).mount(window.splide.Extensions);



// index banner
document.addEventListener("DOMContentLoaded", function () {
  var bannerSlider = document.querySelector(".banner-slider");
  if (bannerSlider) {
    var splide = new Splide(".banner-slider", {
      type: 'fade',
      perPage: 1,
      arrows: false,
      pagination: false,
      rewind: true,       // Enables looping
      autoplay: false,
      interval: 4000,     // 4 seconds
      pauseOnHover: false,
      pauseOnFocus: false,
    });
    splide.mount();
  }
});


// index faq
document.addEventListener("DOMContentLoaded", function (){

     document.querySelectorAll(".question").forEach(function (item){
        item.addEventListener("click", function (){
         this.parentElement.classList.toggle("active");

          // hide show div
         const nextdiv = this.nextElementSibling;
          if (window.getComputedStyle(nextdiv).display == "none"){
               nextdiv.style.display = "block";

          }else{
               nextdiv.style.display = "none";
          }


         // sibling process
         const topparent = this.parentElement.parentElement.children;
        
         for( let i=0; i < topparent.length; i++){  
          const siblingcount = topparent[i]; 
              console.log(siblingcount);
            if(siblingcount != this.parentElement){
               siblingcount.classList.remove("active");
               const dataText = siblingcount.querySelector(".answer");
                dataText.style.display = "none";
            }
         }           
        });

    });
});




// aos script
AOS.init();


// header menu link open in new window
document.addEventListener("DOMContentLoaded", function () {
    const links = document.querySelectorAll(".cus-header-menu");
    links.forEach(function(link) {
      if (link.href.includes("?new_window")) {
        link.setAttribute("target", "_blank");
      }
    });
  });





// review text update
// setTimeout(() => {
//   const reviewBadge = document.querySelector('.jdgm-prev-badge__text');
//   if (reviewBadge) {
//     reviewBadge.innerHTML = '(4.9/5) <small class="uline">Read Reviews</small>';
//   }
// }, 1200);





// custom buy now btn
document.addEventListener("DOMContentLoaded", function () {
  // Select all buttons
  const ProCards = document.querySelectorAll(".cus-buy-btn-api");
  if (!ProCards.length) return;

  ProCards.forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();

      setTimeout(async () => {
        const urlParams = new URLSearchParams(window.location.search);
        const variantID = urlParams.get("variant");
        const sellingPlanID = urlParams.get("selling_plan");

        if (!variantID) {
          console.error("Variant ID missing in URL.");
          return;
        }

        // Build form data conditionally
        const formData = {
          items: [
            sellingPlanID
              ? { id: variantID, quantity: 1, selling_plan: sellingPlanID }
              : { id: variantID, quantity: 1 }
          ]
        };

        try {
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
            },
            body: JSON.stringify(formData)
          });

          if (!response.ok) throw new Error("Network response was not ok");

          const result = await response.json();
          console.log("Product added to cart:", result);

          // Redirect to cart page after adding
          window.location.href = "/checkout";

        } catch (error) {
          console.error("Error adding to cart:", error);
        }
      }, 1000);
    });
  });
});








// menu active
// document.addEventListener("DOMContentLoaded", function () {
//   document.addEventListener("scroll", onScroll);

//   // Smooth scroll
//   document.querySelectorAll('.header__menu-item').forEach(anchor => {
//     anchor.addEventListener("click", function (e) {
//       const targetId = this.getAttribute("href");

//       // Only prevent default + smooth scroll if it's an anchor link (#)
//       if (targetId.startsWith("#")) {
//         e.preventDefault();

//         document.removeEventListener("scroll", onScroll);

//         // remove active from all links
//         document.querySelectorAll(".header__menu-item").forEach(a => a.classList.remove("active"));
//         this.classList.add("active");

//         const targetEl = document.querySelector(targetId);
//         if (targetEl) {
//           window.scrollTo({
//             top: targetEl.offsetTop + 2,
//             behavior: "smooth"
//           });

//           // After scrolling finishes, re-enable scroll listener + update hash
//           setTimeout(() => {
//             window.location.hash = targetId;
//             document.addEventListener("scroll", onScroll);
//           }, 500);
//         }
//       }
//     });
//   });
// });

// function onScroll() {
//   const scrollPos = document.documentElement.scrollTop || document.body.scrollTop;
//   const headerHeight = document.querySelector("header").offsetHeight || 0; // header height
//   const offset = headerHeight + 100; // 👈 adjust here

//   document.querySelectorAll(".header__menu-item").forEach(currLink => {
//     const href = currLink.getAttribute("href");

//     // Only check anchor links
//     if (href && href.startsWith("#")) {
//       const refElement = document.querySelector(href);
//       if (refElement) {
//         const refTop = refElement.offsetTop - offset;
//         const refBottom = refTop + refElement.offsetHeight;

//         if (refTop <= scrollPos && refBottom > scrollPos) {
//           document.querySelectorAll(".header__menu-item").forEach(a => a.classList.remove("active"));
//           currLink.classList.add("active");
//         } else {
//           currLink.classList.remove("active");
//         }


        

//       }
//     }
//   });
// }


$(document).ready(function () {
    $(document).on("scroll", onScroll);

    // Smooth scroll for anchor links only
    $('.header__menu-item[href^="#"]').on('click', function (e) {
        e.preventDefault();
        $(document).off("scroll"); // temporarily disable scroll listener

        $('.header__menu-item').removeClass('active');
        $(this).addClass('active');

        var target = this.hash;
        var $target = $(target);

        if ($target.length) {
            var headerHeight = $('header').outerHeight() || 0;

            $('html, body').stop().animate({
                scrollTop: $target.offset().top - headerHeight + 2
            }, 500, 'swing', function () {
                window.location.hash = target;
                $(document).on("scroll", onScroll);
            });
        }
    });
});

function onScroll() {
    var scrollPosition = $(document).scrollTop();
    var headerHeight = $('header').outerHeight() || 0;

    // Only check anchor links
    $('.header__menu-item[href^="#"]').each(function () {
        var currentLink = $(this);
        var target = currentLink.attr("href");
        var $refElement = $(target);

        if ($refElement.length) {
            var refTop = $refElement.offset().top - headerHeight;
            var refBottom = refTop + $refElement.outerHeight();

            if (scrollPosition >= refTop && scrollPosition < refBottom) {
                $('.header__menu-item').removeClass("active");
                currentLink.addClass("active");
            }
        }
    });
}







document.addEventListener("DOMContentLoaded", function () {
  const nav = document.querySelector(".product-navigation-inner");
  const stickyClass = "is-sticky"; // You can rename this class
  const offsetTop = nav.offsetTop; // Point where sticky starts

  window.addEventListener("scroll", function () {
    if (window.scrollY > offsetTop) {
      nav.classList.add(stickyClass);
    } else {
      nav.classList.remove(stickyClass);
    }
  });
});




